// extracted by mini-css-extract-plugin
module.exports = {"label_spec":"button_label_spec__1Cf0p","custom_btn_primary":"button_custom_btn_primary__1bLrt","disabled":"button_disabled__2bvwW"};